import {useCurrentState} from "../globalState";
import React, {useState} from "react";
import {withRouter} from "react-router-dom";
import {Typography, MenuItem} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {apiPost} from "../api";
import snackbar from "../snackbar";

const templateTypes = [
    {value: "reminder", label: "Reminder"},
    {value: "signed", label: "All Signed"},
    {value: "signed_by", label: "Signed By (next signer)"},
    {value: "declined", label: "Declined"},
    {value: "last_reminder", label: "Last Reminder Sent"},
];

function AdminPage() {
    let [, setTitle] = useCurrentState("title");
    let [user] = useCurrentState("user");
    let [email, setEmail] = useState("");
    let [signRequestId, setSignRequestId] = useState("");
    let [templateType, setTemplateType] = useState("reminder");
    let [loading, setLoading] = useState(false);

    setTitle("Admin");

    if (user.id !== 1) {
        return <div style={{padding: 16}}>Not authorized.</div>;
    }

    let submit = () => {
        setLoading(true);
        apiPost("admin/send-test-email", {
            email: email,
            sign_request_id: signRequestId,
            template_type: templateType,
        }).then(() => {
            snackbar("Test email sent successfully!");
        }, (err) => {
            snackbar("Error: " + (err.response && err.response.data ? err.response.data.message : "unknown error"));
        }).finally(() => setLoading(false));
    };

    return (
        <div style={{padding: 16}}>
            <Card>
                <CardContent>
                    <Typography variant="h5" component="h2">Send Test Email</Typography>
                    <TextField
                        label="Sign Request ID"
                        value={signRequestId}
                        onChange={(e) => setSignRequestId(e.target.value)}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        select
                        label="Email Template"
                        value={templateType}
                        onChange={(e) => setTemplateType(e.target.value)}
                        fullWidth
                        margin="normal"
                    >
                        {templateTypes.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Send to email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        margin="normal"
                    />
                </CardContent>
                <CardActions>
                    <Button onClick={submit} disabled={loading || !email || !signRequestId} color="primary">
                        Send
                    </Button>
                </CardActions>
            </Card>
        </div>
    );
}

export default withRouter(AdminPage);
